import React, { useState, useEffect, useRef } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Logo from '../../assets/img/logo.png';
import LogoCrest from '../../assets/img/logo-crest.png';
import { BsGrid, BsSendArrowDown, BsPhoneFlip, BsSendPlus, BsChatDots } from "react-icons/bs";
import { RiWallet3Line } from "react-icons/ri";
import { GoCreditCard } from "react-icons/go";
import { IoSettingsOutline } from "react-icons/io5";
import { TbMessages } from "react-icons/tb";
import { BsQuestionCircle } from "react-icons/bs";
import { HiOutlineLogout } from "react-icons/hi";
import { GrTransaction } from "react-icons/gr";
import { IoCloseCircleOutline } from "react-icons/io5";
import Img1 from '../../assets/img/learn_more.png';
import Img2 from '../../assets/img/userProf_pic.png';
import { BsSendArrowUp } from "react-icons/bs";
import { MdOutlineCreditScore } from "react-icons/md";
import { HiLink, HiOutlineTrophy, HiOutlineUsers } from "react-icons/hi2";
import { AiOutlineMessage } from "react-icons/ai";
import { GrUserSettings } from "react-icons/gr";
import { VscBellDot } from "react-icons/vsc";
import { logout } from '../../actions/auth';
import { SiConvertio } from 'react-icons/si';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { FiMail, FiCopy, FiCheck, FiExternalLink } from 'react-icons/fi';
import { FaWhatsapp } from 'react-icons/fa6';
import { Headphone } from 'iconsax-react';
import { User2Icon } from 'lucide-react';


function Sidebar({ userDetails, isSidebarOpen, toggleSidebar }) {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const [openMenu, setOpenMenu] = useState(null);
    const [copiedEmail, setCopiedEmail] = useState(false);
    const closeSupportModalRef = useRef(null);

    const handleCopyEmail = () => {
        navigator.clipboard.writeText("info@cardplot.com");
        setCopiedEmail(true);
        toast.success("Support email copied to clipboard!");
        setTimeout(() => setCopiedEmail(false), 2500);
    };

    const handleOpenMailto = () => {
        closeSupportModalRef.current?.click();
        toast.info("Redirecting to email inbox...", {
            toastId: "contact-support-toast",
            autoClose: 2000
        });
        window.location.href = "mailto:info@cardplot.com?subject=Support%20Request%20-%20Cardplot";
    };

    const handleOpenGmail = () => {
        closeSupportModalRef.current?.click();
        toast.info("Redirecting to Gmail inbox...", {
            toastId: "contact-support-gmail-toast",
            autoClose: 2000
        });
        window.open("https://mail.google.com/mail/?view=cm&fs=1&to=info@cardplot.com&su=Support%20Request%20-%20Cardplot", "_blank");
    };

    const handleStartLiveChat = () => {
        closeSupportModalRef.current?.click();
        if (window.Tawk_API && typeof window.Tawk_API.maximize === 'function') {
            window.Tawk_API.maximize();
        } else {
            toast.info("Connecting to live chat...", {
                toastId: "tawk-live-chat-toast",
                autoClose: 2000
            });
        }
    };

    useEffect(() => {
        if (window.Tawk_API && userDetails) {
            const setAttributes = () => {
                if (typeof window.Tawk_API.setAttributes === 'function') {
                    window.Tawk_API.setAttributes({
                        name: userDetails.full_name || userDetails.username || 'User',
                        email: userDetails.email || '',
                    }, function(error) {});
                }
            };
            if (window.Tawk_API.isChatMaximized) {
                setAttributes();
            } else {
                window.Tawk_API.onLoad = setAttributes;
                setAttributes();
            }
        }
    }, [userDetails]);

    useEffect(() => {
        const path = location.pathname;
        if (path.startsWith("/user/add_money") || 
            path.startsWith("/user/send_money") || 
            path.startsWith("/user/converter") || 
            path.startsWith("/user/withdraw_money") || 
            path.startsWith("/user/request_money") || 
            path.startsWith("/user/payment_links") || 
            path.startsWith("/user/bill_payments")) {
            setOpenMenu("payments");
        } else if (path.startsWith("/user/chatspace") || 
                   path.startsWith("/user/admin_support") || 
                   path.startsWith("/user/notifications")) {
            setOpenMenu("messages");
        } else {
            setOpenMenu(null);
        }
    }, [location.pathname]);

    const toggleMenu = (menu) => {
        setOpenMenu((prev) => (prev === menu ? null : menu));
    };

    const handleLogout = async () => {
        const token = localStorage.getItem('token');
        // const email = localStorage.getItem('userEmail'); 
    
        if (!token) {
            // console.error("User credentials missing!");
            return;
        }
    
        // const credentials = { token, email };
    
        try {
            await logout(token, navigate, dispatch);
        } catch (error) {
            // console.error("Logout failed:", error.message);
        }
    };

  return (
    <>
        <aside className={`sidebar ${isSidebarOpen ? "sidebar__icon-display" : ""}`}>
            <div className="d-flex">
                {/* <button className="toggle-btn" type="button">
                 <BsGrid />
                </button> */}
                <div className="sidebar-logo d-flex align-items-center gap-4">
                    <Link to="/" title='Go to Homepage' className='d-flex align-items-center gap-1 ps-4 pt-3'>
                       {/* <img src={Logo} alt="" className='img-fluid icon__sidebar-hide'/> */}
                       <img src={LogoCrest} alt="" className='icon__sidebar-show' width="40px" height="40px"/>
                       <h2 className='icon__sidebar-hide'>Cardplot</h2>
                    </Link>
                    <span role='button' onClick={toggleSidebar} className='sidebar__close-btn icon__size pt-2 text-white'><IoCloseCircleOutline /></span>
                </div>
            </div>
            <hr />
            <div className="sidebar__content">
                <ul className="sidebar-nav py-1 pb-5">
                    <li className="sidebar-item">
                        <Link to="/user/dashboard" className={`sidebar-link ${location.pathname === "/user/dashboard" ? "active" : ""}`}>
                            <BsGrid />
                            <span>Dashboard</span>
                        </Link>
                    </li>
                    <li className="sidebar-item">
                        <Link to="/user/wallets" className={`sidebar-link ${location.pathname === "/user/wallets" ? "active" : ""}`}>
                            <RiWallet3Line />
                            <span>Wallets</span>
                        </Link>
                    </li>
                    <li className="sidebar-item">
                        <Link to="/user/cards" className={`sidebar-link ${location.pathname.startsWith("/user/cards") ? "active" : ""}`}>
                            <GoCreditCard />
                            <span>Cards</span>
                        </Link>
                    </li>
                    <li className="sidebar-item">
                        <Link to="#" onClick={() => toggleMenu("payments")} 
                            className={`sidebar-link has-dropdown ${openMenu === "payments" ? "active" : "collapsed"}`} 
                            data-bs-toggle="collapse"
                        >
                            <MdOutlineCreditScore />
                            <span>Payments</span>
                        </Link>
                        <ul id="auth" className={`sidebar-dropdown list-unstyled collapse ${openMenu === "payments" ? "show" : ""}`}>
                        {/* <ul id="auth" className="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar"> */}
                            <li className="sidebar-item">
                                <Link to="/user/add_money" className={`sidebar-link ${location.pathname === "/user/add_money" ? "active" : ""}`}>
                                    <BsSendPlus />
                                    <span>Add Money</span>
                                </Link>
                            </li>
                            <li className="sidebar-item">
                                <Link to="/user/send_money" className={`sidebar-link ${location.pathname.startsWith("/user/send_money") ? "active" : ""}`}>
                                    <BsSendArrowUp />
                                    <span>Send Money</span>
                                </Link>
                            </li>
                            <li className="sidebar-item">
                                <Link to="/user/converter" className={`sidebar-link ${location.pathname === "/user/converter" ? "active" : ""}`}>
                                    <SiConvertio />
                                    <span>Convert Money</span>
                                </Link>
                            </li>
                            {/* <li className="sidebar-item">
                                <Link to="/user/withdraw_money" className={`sidebar-link ${location.pathname === "/user/withdraw_money" ? "active" : ""}`}>
                                    <BsSendArrowDown />
                                    <span>Withdraw Money</span>
                                </Link>
                            </li> */}
                            {/* <li className="sidebar-item">
                                <Link to="/user/request_money" className="sidebar-link">
                                    <BsSendArrowDown />
                                    <span>Request Money</span>
                                </Link>
                            </li> */}
                            {/* <li className="sidebar-item">
                                <Link to="/user/payment_links" className="sidebar-link">
                                    <HiLink />
                                    <span>Payments Links</span>
                                </Link>
                            </li> */}
                            <li className="sidebar-item">
                                <Link to="/user/bill_payments" className="sidebar-link">
                                    <BsPhoneFlip />
                                    <span>Airtime / Bill Payments</span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                    <li className="sidebar-item">
                        <Link to="/user/transactions" className={`sidebar-link ${location.pathname === "/user/transactions" ? "active" : ""}`}>
                            <GrTransaction />
                            <span>Transactions</span>
                        </Link>
                    </li>
                    <li className="sidebar-item">
                        <Link to="#" onClick={() => toggleMenu("referrals")} 
                            className={`sidebar-link has-dropdown ${openMenu === "referrals" ? "active" : "collapsed"}`} 
                            data-bs-toggle="collapse"
                        >
                            <HiOutlineUsers />
                            <span> Referrals </span>
                        </Link>
                        <ul id="auth" className={`sidebar-dropdown list-unstyled collapse ${openMenu === "referrals" ? "show" : ""}`}>
                        {/* <ul id="auth" className="sidebar-dropdown list-unstyled collapse" data-bs-parent="#sidebar"> */}
                            <li className="sidebar-item">
                                <Link to="/user/referrals-and-earnings" className={`sidebar-link ${location.pathname === "/user/referrals-and-earnings" ? "active" : ""}`}>
                                    <HiOutlineUsers />
                                    <span>Referrals & Earnings</span>
                                </Link>
                            </li>
                            <li className="sidebar-item">
                                <Link to="/user/referral-contests" className={`sidebar-link ${location.pathname === "/user/referrals-contests" ? "active" : ""}`}>
                                    <HiOutlineTrophy />
                                    <span> Referral Contest </span>
                                </Link>
                            </li>
                        </ul>
                    </li>
                     <li className="sidebar-item">
                        <Link to="#" className={`sidebar-link ${location.pathname === "/user/contact" ? "active" : ""}`} data-bs-toggle="modal" data-bs-target="#contactSupportModal">
                            <BsQuestionCircle />
                            <span>Contact us</span>
                        </Link>
                    </li>
                    <li className="sidebar-item">
                        <Link to="/user/admin_support" className={`sidebar-link  ${location.pathname === "/user/admin_support" ? "active" : ""}`}>
                            <Headphone />
                            <span>Support</span>
                        </Link>
                    </li> 
                    <li className="sidebar-item">
                        <Link to="/user/settings" className={`sidebar-link ${location.pathname === "/user/settings" ? "active" : ""}`}>
                            <User2Icon />
                            <span>Account</span>
                        </Link>
                    </li>
                    <li className='sidebar-item'>
                        <Link onClick={handleLogout} className="sidebar-link">
                            <HiOutlineLogout />
                            <span>Logout</span>
                        </Link>
                    </li>
                </ul>
                <div className="sidebar-footer icon__sidebar-hide">
                    <div className="reward__container mb-5">
                        
                        <div className="reward__content">
                            <img src={Img1} alt="" className='img-fluid'/>
                            <p>
                            Get reward with our referral program, you can earn up to #10,000
                            </p>
                            <Link to="#" className="btn btn__learn__more">Learn more</Link>
                        </div>
                    </div>
                    <div className='d-flex align-items-center justify-content-start footer__profile__container gap-2'>
                        <img src={userDetails?.avatar || Img2} alt="" className='img-fluid'/>
                        <div className="footer__profile__content"> 
                            {userDetails?.username ? (
                                <h6>@{userDetails?.username}</h6>
                            ) : (
                                <button 
                                    className="btn btn-link p-0 add__username__btn" 
                                    data-bs-toggle="modal" 
                                    data-bs-target="#addUsernameModal"
                                >
                                    Click to add username
                                </button>
                            )}
                            <h5 className='mb-0'>{userDetails?.account_type === 'personal' ? 'Personal' : 'Business'} Account</h5>
                            {/* <h6 className='text-muted'><small>Account Number: {userDetails?.bank_account[0]?.account_number}</small></h6> */}
                        </div>                 
                    </div>
                    <div className='copyright'>
                    <p className='sidebar__footer__text'>&copy; 2025 Cardplot Ltd</p>
                    </div>
                </div>
            </div>


        </aside>

        {/* Contact Support Modal */}
        <section className="modal fade" id="contactSupportModal" tabIndex="-1" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content position-relative border-0 shadow-lg" style={{ borderRadius: '20px', overflow: 'hidden' }}>
                    <div className="d-flex justify-content-end pe-3 pt-3" style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        zIndex: 1,
                    }}>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" ref={closeSupportModalRef} />
                    </div>

                    <div className="modal-body p-4 p-md-5 text-center">
                        <div className="mb-3">
                            <BsQuestionCircle className="text-primary" style={{ fontSize: '3rem' }} />
                        </div>
                        <h4 className="mb-2 fw-bold" style={{ color: '#19064B' }}>Contact Support</h4>
                        <p className="text-muted mb-4 small">
                            Need help? Reach out to our support team and we'll get back to you promptly.
                        </p>

                        <div className="d-flex align-items-center justify-content-between p-3 rounded-3 mb-4" style={{ backgroundColor: '#F8F9FA', border: '1px solid #E0E4EC' }}>
                            <div className="d-flex align-items-center gap-2 text-start overflow-hidden">
                                <FiMail className="text-primary fs-5 flex-shrink-0" />
                                <span className="fw-semibold text-truncate" style={{ fontSize: '14px', color: '#19064B' }}>
                                    info@cardplot.com
                                </span>
                            </div>
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-primary d-flex align-items-center gap-1 ms-2"
                                onClick={handleCopyEmail}
                                style={{ borderRadius: '8px', fontSize: '12px', padding: '5px 12px' }}
                            >
                                {copiedEmail ? (
                                    <><FiCheck className="text-success" /> Copied!</>
                                ) : (
                                    <><FiCopy /> Copy</>
                                )}
                            </button>
                        </div>

                        <div className="d-grid gap-2">
                            <button 
                                type="button" 
                                data-bs-dismiss="modal"
                                onClick={handleStartLiveChat} 
                                className="primary__btn py-3 d-flex align-items-center justify-content-center gap-2 border-0 w-100"
                                style={{ borderRadius: '12px', fontSize: '14px' }}
                            >
                                <BsChatDots size={16} /> Start Live Chat
                            </button>
                            <a 
                                href="https://wa.me/447347949022?text=Hello%20Cardplot%20Support"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn py-2 d-flex align-items-center justify-content-center gap-2 text-decoration-none shadow-sm"
                                style={{ 
                                    borderRadius: '12px', 
                                    fontSize: '14px', 
                                    backgroundColor: '#25D366', 
                                    color: '#ffffff', 
                                    fontWeight: '600',
                                    border: 'none',
                                    transition: 'all 0.2s ease'
                                }}
                            >
                                <FaWhatsapp size={18} /> Chat on WhatsApp
                            </a>
                            <button 
                                type="button" 
                                data-bs-dismiss="modal"
                                onClick={handleOpenMailto} 
                                className="btn btn-outline-primary py-2 d-flex align-items-center justify-content-center gap-2"
                                style={{ borderRadius: '12px', fontSize: '14px' }}
                            >
                                <FiMail size={16} /> Open Email Inbox
                            </button>
                            <button 
                                type="button"
                                data-bs-dismiss="modal"
                                onClick={handleOpenGmail}
                                className="btn btn-outline-secondary py-2 d-flex align-items-center justify-content-center gap-2"
                                style={{ borderRadius: '12px', fontSize: '14px' }}
                            >
                                <FiExternalLink size={15} /> Open in Gmail Web
                            </button>
                            <button type="button" className="btn text-decoration-none mt-2 text-muted" data-bs-dismiss="modal" style={{ fontSize: '13px' }}>
                                Maybe later
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
)
}

export default Sidebar